const GET_HOME_PAGE_DATA = 'GET_HOME_PAGE_DATA';

export { GET_HOME_PAGE_DATA }